import * as React from "react";
import {Box} from "@mui/material";

export default function StackedAgingBar({tiers}) {
    return (
        <Box sx={(theme) => ({
            display: 'flex', height: 14, borderRadius: 0.5, overflow: 'hidden', gap: 0.25,
            backgroundColor: theme.palette.divider, marginBottom: 2,
        })}>
            {tiers.filter(tier => tier.stackedPercentage > 0).map(tier => (
                <Box key={tier.code}
                     title={`${tier.label}: ${tier.amount} (${tier.stackedPercentage.toFixed(1)}%)`}
                     sx={{width: `${tier.stackedPercentage}%`, minWidth: 2, backgroundColor: tier.color}}/>
            ))}
        </Box>
    );
}
